import { render } from "./NewFeatureToastComponent.vue?vue&type=template&id=a3ba1624&ts=true"
import script from "./NewFeatureToastComponent.vue?vue&type=script&lang=ts"
export * from "./NewFeatureToastComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__